import { useEffect, useState } from 'react';
import { Card, Button, Col, Row } from 'antd';
import { ToastContainer } from 'react-toastify';
import {
  handleDeleteApi,
  handlePostApi,
  handleUpdatePostApi,
} from '@/api/crud';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import AddLayout from '../modals/AddLayout';
import '../defaultBarcodeCSS.css';
import BarcodePreview from '../components/BarcodePreview';
import { useTransactionContext } from '@/context/TransactionContext';
import { barcodeApiEndPoints, branchAccessEndpoints } from '@/api/endpoints';
import { useLocation } from 'react-router-dom';
import { DeleteFilled, EditFilled } from '@ant-design/icons';
import Link from 'antd/es/typography/Link';
import options from '@/utils/barcode/barcodePrintTags';
import GlobalModal from '@/utils/modal/Modal';
import { Back } from '../back';

const LayoutSettings = () => {
  const [addLayoutModalVisible, setAddLayoutModalVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [delId, setDelId] = useState(null);
  const [barcodePrintFormats, setBarcodePrintFormats] = useState([]);
  const [selectedLayout, setSelectedLayout] = useState(null);
  const [loading, setLoading] = useState(false);
  const [branchList, setBranchList] = useState([]);
  const location = useLocation();
  const { branchId, referenceId } = location.state || [];

  const handleOk = () => {
    setOpen(false);
    handleDeleteApi(delId, barcodeApiEndPoints.deletePrintLayout, setLoading);
  };

  useEffect(() => {
    async function fetchBarcodeLayouts() {
      const branches = await branchAccessEndpoints.retrieveList();
      const printLayouts = await barcodeApiEndPoints.printLayouts();
      setBarcodePrintFormats(
        printLayouts.data.data.filter((layout) => layout.branchId === branchId),
      );
      setBranchList(branches.data.data);
    }
    fetchBarcodeLayouts();
  }, [open, addLayoutModalVisible]);

  return (
    <div>
      <ToastContainer />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Back />
        <GlobalDivider name="Layout Settings" />
      </div>
      <div style={{ padding: '20px' }}>
        <Row gutter={[16, 0]} justify="space-between">
          <Col xs={{ span: 24 }} lg={{ span: 8 }}></Col>
          <Col>
            <Button
              onClick={() => {
                setAddLayoutModalVisible(true);
              }}
            >
              Create Layout
            </Button>
          </Col>
        </Row>
      </div>
      <div
        style={{
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
        }}
      ></div>

      <GlobalModal
        isVisible={open}
        onConfirm={handleOk}
        onClose={() => setOpen(false)}
        type="delete"
      />
      <AddLayout
        visible={addLayoutModalVisible}
        optionList={options}
        onClose={() => {
          setAddLayoutModalVisible(false);
          setSelectedLayout(null);
        }}
        selectedLayout={selectedLayout}
        branchList={branchList}
      />

      <div style={{ display: 'flex', gap: '20px' }}>
        {barcodePrintFormats.map((format, index) => (
          <Card key={index}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '16px',
              }}
            >
              <h3 style={{ marginBottom: '1rem' }}>{format.heading}</h3>
              <div style={{ display: 'flex', gap: '8px' }}>
                <div
                  className="ant-button-edit"
                  onClick={() => {
                    setAddLayoutModalVisible(true);
                    setSelectedLayout(format);
                  }}
                >
                  <Link size="medium" className="edit">
                    <EditFilled className="text-blue-300" />
                  </Link>
                </div>
                <div className="ant-button-delete">
                  <Link
                    size="medium"
                    onClick={() => {
                      setOpen(true);
                      setDelId(format.referenceId);
                    }}
                  >
                    <DeleteFilled className="delete" />
                  </Link>
                </div>
              </div>
            </div>
            <BarcodePreview format={format} />
          </Card>
        ))}
      </div>
    </div>
  );
};

export default LayoutSettings;
